/**
 * Customized box shadows.
 *
 * Chakra Reference: https://chakra-ui.com/docs/theming/theme
 * PINS Figma Reference: https://www.figma.com/file/Z8kfGR6BNKMm3XvQGhKcBD/PINS-Advantage-2021-Design-System?node-id=384%3A187
 *
 */
const shadows = {
  soft1: '0px 18px 40px rgba(112, 144, 176, 0.12)',
  soft2: '0px 40px 58px rgba(112, 144, 176, 0.12)',
  soft3: '0px 40px 58px rgba(112, 144, 176, 0.12)',
  base1: '0px 10px 60px rgba(0, 0, 0, 0.08)',
  base2: '0px 20px 46px -8px rgba(0, 0, 0, 0.08)',
  base3: '0px 14px 54px -10px rgba(0, 0, 0, 0.08)',
  sharp1: '0px 4px 14px rgba(0, 0, 0, 0.25)',
  sharp2: '0px 8px 6px rgba(0, 0, 0, 0.25)',
  sharp3: '0px 8px 28px rgba(0, 0, 0, 0.25)',
  sharp4: '4px 4px 12px rgba(174, 197, 216, 0.15)',
  focus: '0 0 0 4px rgba(185, 220, 255, 1)',
  accent: '0px 6px 12px rgba(63, 140, 255, 0.263686)',
  hover: '0px 20px 46px -8px rgba(100, 132, 162, 0.25)',
  requirementBlock: '4px 4px 12px rgba(174, 197, 216, 0.15), -4px -4px 12px rgba(244, 249, 254, 0.5)',
  hover2: '4px 4px 8px rgba(16, 104, 217, 0.15)'
};

export default shadows;
